import { useMemo } from 'react';

// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details } from '@return-rabbit/nexus';

import { Text } from 'ui-components/components/text';
import { Divider } from 'ui-components/components/divider';
import { FlexRow, FlexColumn, Gap } from 'ui-components/components/flex';

import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';
import { RefundOptions } from './refund-options';
import { ShippingCostWaiveOffCheckbox } from './shipping-cost-waive-off-checkbox';
import { ReturnDetailSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';

import { messages } from './messages';
import { ReturnPaymentTypes } from '../../../../../enums/return-payment-types';
import style from './styles.module.less';

export function ReturnPayment() {
  const { isReturnCreatedInAdvancedMode } = Details.useReturnMode();

  if (!isReturnCreatedInAdvancedMode) return null;

  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style.content}
      headerContent={<SectionTitle messageDescriptor={messages.sectionHeaderTitle} />}
      sectionContent={<Content />}
      sectionId={ReturnDetailSectionId.ReturnPaymentOptions}
    />
  );
}

function Content() {
  const { options } = Details.useRefundInfo();

  const hasRefund = useMemo(() => {
    const opmAmount = options?.[ReturnPaymentTypes.OriginalPaymentMethod.key]?.total_amount ?? 0;
    const giftCardAmount = options?.[ReturnPaymentTypes.GiftCard.key]?.total_amount ?? 0;
    return [opmAmount, giftCardAmount].some((amount) => amount > 0);
  }, [options]);

  return (
    <FlexRow className={style.container} gap={Gap.Space16}>
      <FlexColumn className={style.cell} gap={Gap.Space8}>
        <Text textType='Label' value={messages.shippingCostOptionsTitle} />
        <ShippingCostWaiveOffCheckbox />
      </FlexColumn>
      {hasRefund && (
        <>
          <Divider className={style.divider} orientation='vertical' />
          <FlexColumn className={style.cell} gap={Gap.Space8}>
            <Text textType='Label' value={messages.refundMethodTitle} />
            <RefundOptions />
          </FlexColumn>
        </>
      )}
    </FlexRow>
  );
}
